var normalizeComponent = require("!../../../../../../../../node_modules/vue-loader/lib/component-normalizer")
/* script */
var __vue_script__ = require("!!babel-loader?{\"cacheDirectory\":true,\"presets\":[[\"@babel/preset-env\",{\"modules\":false,\"targets\":{\"browsers\":[\"> 2%\"]},\"forceAllTransforms\":true}]],\"plugins\":[\"@babel/plugin-proposal-object-rest-spread\",[\"@babel/plugin-transform-runtime\",{\"helpers\":false}]]}!../../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./form.vue")
/* template */
var __vue_template__ = require("!!../../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-8a868c18\",\"hasScoped\":false,\"buble\":{\"transforms\":{}}}!../../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./form.vue")
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./modules/Restaurant/Resources/assets/js/views/v2/dining_tables/form.vue
// module id = tjLA
// module chunks = 0